import React, { useState } from 'react'
import AOS from "aos"; // Import AOS library
import CustomHelmet from '../components/CustomHelmet'
import NewLaunchSec from '../sections/launch/NewLaunchSec'
import * as constants from "../constants";
import { fetchAPI } from '../helper/fetchAPI';
import FullScreenLoader from '../components/FullScreenLoader';
import Banner from '../components/Banner';
import { t } from 'i18next';
import Breadcrumb from '../components/Breadcrumb';
import DeveloperStartsFrom from '../components/DeveloperStartsFrom';
import PropertyList from '../components/PropertyList';
import { decodeId } from '../helper/helperFunction';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCountryPrefix } from '../routes/useCountryPrefix';
import NotFoundSec from '../sections/pageNotFound/NotFoundSec';

const NewLaunch = () => {
    const countryPrefix = useCountryPrefix();

    const { idProject } = useParams();
    let apiUrl = process.env.REACT_APP_API_URL;
    const { i18n } = useTranslation();

    const [isLoaded, setIsLoaded] = useState(false);
    const [pageIndex, setPageIndex] = useState(1);

    const [contactDetails, setContactDetails] = useState();
    const [developerDetails, setDeveloperDetails] = useState();
    const [projectDetails, setProjectDetails] = useState();
    const [propertiesSection, setPropertiesSection] = useState({
        items: [],
        totalPages: 1,
        pageIndex: 1,
    });
    const [loadingMore, setLoadingMore] = useState(false);


    const isArabic = i18n.language === "ar";
    const language = isArabic ? "ar" : "en";


    const fetchData = async (pageIndex) => {

        try {
            apiUrl = `${apiUrl}${constants.developerprojectproperty}?language=${language}&projectId=${decodeId(idProject)}&PageIndex=${pageIndex}&PageSize=5&region_id=${countryPrefix}`;
            const resListing = await fetchAPI(apiUrl, "Get");
            if (resListing?.status === 200) {

                setPropertiesSection((prevData) => ({
                    ...prevData,
                    items: [...(prevData?.items || []), ...(resListing?.data?.items || [])],
                    totalPages: resListing?.data?.totalPages ?? prevData.totalPages,
                    pageIndex: resListing?.data?.pageIndex ?? prevData.pageIndex,
                }));
                setContactDetails(resListing?.data?.contactDetails)
                setDeveloperDetails(resListing?.data?.developerDetails)
                setProjectDetails(resListing?.data?.projectDetails)
                setIsLoaded(true)
                setLoadingMore(false)
            }
            else {
                setLoadingMore(false)
                setIsLoaded(true)
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    const handleLoadMore = () => {
        setLoadingMore(true)
        setPageIndex(prev => prev + 1);
    };


    React.useEffect(() => {
        AOS.init();

        fetchData(pageIndex);
    }, [pageIndex]);

    const pathLang = isArabic ? "/ar" : "";
    const pathName = [
        { name: t("home"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}` },
        { name: t("new_launch") }
    ];

    if (!isLoaded) {
        return (
            <FullScreenLoader />
        )
    }
    return (
        <>
            <CustomHelmet
                title={"Exclusive Real Estate Across Egypt"}
                desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
            />
            <Banner
                title={t("new_launch")}
                desc={t("banner_desc")}></Banner >
            <Breadcrumb pathName={pathName}></Breadcrumb>

            <DeveloperStartsFrom companyName={`${projectDetails?.projectName}`} location={projectDetails?.location} priceStart={developerDetails?.minPrice || 0} priceEnd={developerDetails?.maxPrice || 0} developerLogo={developerDetails?.thumbnailImage} phone={contactDetails?.phone} whatsApp={contactDetails?.whatsApp}></DeveloperStartsFrom>

            {projectDetails !== undefined && propertiesSection !== undefined ? (
                <>
                    <NewLaunchSec data={projectDetails} />
                    <PropertyList
                        propertyTypeData={[]}
                        propertiesData={propertiesSection}
                        developerDetailData={developerDetails}
                        contact={contactDetails}
                        isFilter={false}
                        cssClass={"pt-4"}
                        isUrlAppend={true}
                        onLoadMore={handleLoadMore}
                        loadingMore={loadingMore}
                    />
                </>
            ) : (

                <NotFoundSec title={t("opps")} desc={t("property_not_found")} img={"/assets/img/not-found.svg"} />
            )}
        </>

    )
}

export default NewLaunch